import React, { Fragment, useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { withProps } from 'recompose';
import { pick, splitEvery } from 'ramda';
import Slider from 'js/components/common/Slider';
import style from './index.scss';

export const SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};

// Possibly, there's better way
export const getRightMargin = (itemRef) => {
    let marginRight = parseFloat(getComputedStyle(itemRef).marginRight);
    if (marginRight !== 0) {
        return marginRight;
    }

    // for single element in slide possible margin won't be drawn hence we couldn't be able to calculate it
    const el = document.createElement('span');
    itemRef.parentElement.appendChild(el);
    marginRight = parseFloat(getComputedStyle(itemRef).marginRight);
    itemRef.parentElement.removeChild(el);

    return marginRight;
};

export const calcSlideWidth = (ref) => {
    const { current } = ref;
    const { paddingLeft, paddingRight } = getComputedStyle(current);

    return current.offsetWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
};

export const calcItemWidth = (ref) => {
    const { current } = ref;
    const marginRight = getRightMargin(current);

    return current.offsetWidth + parseFloat(marginRight);
};

export const sliderClassNames = pick(['sliderContainer', 'slide'], style);

export const ItemsSlider = ({
    items,
    Item,
    className = '',
    itemsPerSlide,
    slideRef,
    itemRef,
    ...other
}) => (
    <Slider options={SLIDER_OPTIONS}
        rotation={false}
        swipe={false}
        className={`${style.slider} ${className}`}
        classNames={sliderClassNames}
        refs={{ slide: slideRef }}
        {...other}>

        {splitEvery(itemsPerSlide, items)
            .map((slide, i) => (
                <Fragment key={`${slide.length}_${i}`}>
                    {slide.map((data, index) =>
                        <Item
                            {...data}
                            key={index}
                            {...(i === 0 && index === 0 && { itemRef })}
                        />
                    )}
                </Fragment>
            ))}
    </Slider>
);

export const useItemsPerSlide = ({ slideRef, itemRef }) => {
    const [itemsPerSlide, setItemsPerSlide] = useState(1);
    const [, setIsMounted] = useState(false);

    const callback = () => {
        const itemWidth = calcItemWidth(itemRef);
        const slideWidth = calcSlideWidth(slideRef);
        const totalItemsCount = Math.floor(slideWidth / itemWidth);

        if (totalItemsCount >= 1 && itemsPerSlide !== totalItemsCount) {
            setItemsPerSlide(totalItemsCount);
        }
    };

    // hook for trigger next useEffect with fulfilled ref
    useEffect(() => setIsMounted(true), []);

    useEffect(() => {
        const observer = new ResizeObserver(callback);
        slideRef.current && observer.observe(slideRef.current);

        return () => observer.disconnect();
    });

    return {
        itemsPerSlide
    };
};

export default withProps(
    () => {
        const itemRef = useRef();
        const slideRef = useRef();
        const { itemsPerSlide } = useItemsPerSlide({ slideRef, itemRef });

        return {
            itemRef,
            slideRef,
            itemsPerSlide
        };
    }
)(ItemsSlider);
